"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.equalWithTolerance = void 0;
const DEFAULT_TOLERANCE = 2 ** -16;
/**
 * @summary Checks if two float numbers are equal within a tolerance.
 *
 * Compares two floating-point numbers using a tolerance. This means that the two numbers just need to
 * be close together and not equal bit-for-bit. By default, the tolerance is `2^-16`, but can be overwritten
 * using the third parameter.
 *
 * @param {number | undefined} n1
 * @param {number | undefined} n2
 * @param {number | undefined} [tolerance]
 * @returns {boolean}
 *
 * @example
 * if (equalWithTolerance(.1 + .2, .3)) {
 *   // this would not run with simple comparisons
 * }
 */
function equalWithTolerance(n1, n2, tolerance = DEFAULT_TOLERANCE) {
    if (n1 == null && n2 == null)
        return true;
    if (n1 == null || n2 == null)
        return false;
    return Math.abs(n1 - n2) < tolerance;
}
exports.equalWithTolerance = equalWithTolerance;
